export default __webpack_public_path__ + "static/media/yawn.241b3eab.gif";